var map = {
	"./decidim/avatar-multiuser.png": 36043,
	"./decidim/brands/google.svg": 31962,
	"./decidim/cc-badge.png": 25689,
	"./decidim/decidim-logo.svg": 77817,
	"./decidim/default-avatar.svg": 14889,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 76815,
	"./decidim/icons.svg": 83720,
	"./decidim/pattern.png": 10779,
	"./decidim/placeholder-card-g.svg": 64936,
	"./decidim/placeholder-card-l.svg": 53315,
	"./decidim/placeholder.jpg": 94986,
	"./decidim/remixicon.symbol.svg": 78352,
	"./decidim/vendor/leaflet/layers-2x.png": 7721,
	"./decidim/vendor/leaflet/layers.png": 91744,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 66545,
	"./decidim/vendor/leaflet/marker-icon.png": 35608,
	"./decidim/vendor/leaflet/marker-shadow.png": 35847,
	"./decidim/vendor/social-share-button/douban.svg": 26019,
	"./decidim/vendor/social-share-button/email.svg": 81180,
	"./decidim/vendor/social-share-button/facebook.svg": 7496,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 76236,
	"./decidim/vendor/social-share-button/hacker_news.svg": 87920,
	"./decidim/vendor/social-share-button/linkedin.svg": 90426,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 28099,
	"./decidim/vendor/social-share-button/pinterest.svg": 32554,
	"./decidim/vendor/social-share-button/reddit.svg": 32288,
	"./decidim/vendor/social-share-button/telegram.svg": 57541,
	"./decidim/vendor/social-share-button/tumblr.svg": 99682,
	"./decidim/vendor/social-share-button/twitter.svg": 60601,
	"./decidim/vendor/social-share-button/vkontakte.svg": 54003,
	"./decidim/vendor/social-share-button/wechat.svg": 64382,
	"./decidim/vendor/social-share-button/whatsapp.svg": 4950,
	"./decidim/vendor/social-share-button/x.svg": 91060,
	"./decidim/vendor/social-share-button/xing.svg": 18724
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82938;